export default __webpack_public_path__ + "static/media/lp-01-trainer-desktop.ed3ab36b.png";